import script from "./payment.vue?vue&type=script&setup=true&lang=js"
export * from "./payment.vue?vue&type=script&setup=true&lang=js"

import "./payment.vue?vue&type=style&index=0&id=78086726&scoped=true&lang=css"

import exportComponent from "/home/staging-tcms.qpax-tcms.net/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78086726"]])

export default __exports__